import { Input, Select } from "antd";
import "./ManualAssessment.css";
const OptionsInput = ({
  option1,
  option2,
  option3,
  option4,
  setOption1,
  setOption2,
  setOption3,
  setOption4,
  showOptionsLabel = true,
  showHint = false,
  hintText = "",
  showAnswerSelect = false,
  answerSelectMode = "single",
  answerSelectLabel = "Correct Answer",
  answerSelectPlaceholder = "Select the correct answer",
  answerValue = null,
  setAnswerValue = () => {},
  required = false,
}) => {
  // Get all non-empty options for the answer dropdown
  const availableOptions = [option1, option2, option3, option4]
    .filter((o) => o.trim())
    .map((o) => ({ value: o, label: o }));

  return (
    <>
      {/* Options Input Section */}
      {showOptionsLabel && (
        <p className="fieldLabel">
          Options {required && <span style={{ color: "red" }}>*</span>}
        </p>
      )}
      {showHint && (
        <p
          style={{
            fontSize: "11px",
            color: "#666",
            marginTop: -4,
            marginBottom: 8,
          }}
        >
          {hintText}
        </p>
      )}
      <Input
        placeholder="Option 1 *"
        value={option1}
        onChange={(e) => setOption1(e.target.value)}
        className="formInput"
      />
      <Input
        placeholder="Option 2 *"
        value={option2}
        onChange={(e) => setOption2(e.target.value)}
        className="formInput"
      />
      <Input
        placeholder="Option 3 (optional)"
        value={option3}
        onChange={(e) => setOption3(e.target.value)}
        className="formInput"
      />
      <Input
        placeholder="Option 4 (optional)"
        value={option4}
        onChange={(e) => setOption4(e.target.value)}
        className="formInput"
      />

      {/* Answer Selection Section */}
      {showAnswerSelect && (
        <>
          <p className="fieldLabel">
            {answerSelectLabel}{" "}
            {required && <span style={{ color: "red" }}>*</span>}
          </p>
          <Select
            mode={answerSelectMode === "multiple" ? "multiple" : undefined}
            value={answerValue}
            onChange={setAnswerValue}
            className="formInput"
            placeholder={answerSelectPlaceholder}
            style={{ width: "100%" }}
            options={availableOptions}
          />
        </>
      )}
    </>
  );
};

export default OptionsInput;
